export default {
    ws: {},
    setWs: function (newWs) {
        this.ws = newWs
    },
    notReadNum:0,
    notMailReadNum:0
}